import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

import { TENANT } from '../../../tenant'
import { PRODUCT_TEMPLATES } from '../productTemplates'

import { productAccessorGetProductTemplate } from './productAccessorGetProductTemplate'
import { productAccessorIsMedicament } from './productAccessorIsMedicament'

export const productAccessorShouldDisplayReviews = ({
  product,
  tenant,
}: {
  product: PimProductWithVariantsV1
  tenant: TENANT
}): boolean => {
  const isMedicament = productAccessorIsMedicament(product)
  const productTemplate = productAccessorGetProductTemplate({
    flags: product.flags,
    tenant,
  })
  const isRx = productTemplate === PRODUCT_TEMPLATES.RX

  return !isRx && (!isMedicament || TENANT.FR !== tenant)
}
